import { USER_CONTEXT, APP_CONTEXT } from '../actionTypes';
import { setItemToStore } from '../../utils/utils';

export default (state = { workspaceStep: '' }, { type, payload }) => {
  switch (type) {
    case USER_CONTEXT.SET_USER_PROPS:
      return { ...state, ...payload };

    case USER_CONTEXT.EMAIL_SUCCESS:
      return { ...state, isAccountCreated: payload.token };

    case USER_CONTEXT.EMAIL_EXISTS_SUCCESS:
      return { ...state, ...payload };

    case USER_CONTEXT.GET_WORKSPACES_SUCCESS:
      setItemToStore('user', { token: payload.token });
      return {
        ...state,
        loggedInUser: {
          user: payload.user,
          workspaces: payload.workspaces,
        },
      };

    case USER_CONTEXT.ACCEPT_WS_INVITATION_SUCCESS: {
      let updatedWorkspaces = state.loggedInUser.workspaces;
      if (payload.isInvitationAccepted && payload.businessUser)
        updatedWorkspaces = updateWorkspaces(
          payload.businessUser,
          updatedWorkspaces
        );
      return {
        ...state,
        loggedInUser: {
          ...state.loggedInUser,
          workspaces: updatedWorkspaces,
        },
      };
    }

    case USER_CONTEXT.CREATE_WORKSPACE_SUCCESS:
    case USER_CONTEXT.MANAGE_WORKSPACE_SUCCESS:
    case USER_CONTEXT.INVITATION_WORKSPACE_SUCCESS:
      return {
        ...state,
        ...(payload.businessUser && { businessUser: payload.businessUser._id }),
        ...(payload.business && { reference: payload.business.reference }),
        ...(payload.business && { business: payload.business }),
        ...(payload.subscription && {
          subscription: {
            _subscriptionId: payload.subscription,
            _transactionId: payload.transaction,
          },
        }),
        workspaceStep: payload.workspaceStep,
      };

    case USER_CONTEXT.IP_ADDRESS_SUCCESS:
      return {
        ...state,
        geoData: payload.geoData,
      };

    case APP_CONTEXT.SIGNUP_SUCCESS: {
      const { workspaceStep } = payload;
      return {
        ...state,
        workspaceStep,
      };
    }

    case USER_CONTEXT.RESET_USER_PROPS:
      return {};

    default:
      return state;
  }
};

const updateWorkspaces = (businessUser, workspaces = []) => {
  const index = workspaces.findIndex((w) => w._id === businessUser._id);
  if (index !== -1) {
    workspaces[index] = { ...workspaces[index], invitationToken: undefined };
  }

  return workspaces;
};
